import $ from "cash-dom";

export function serializeToObject(form) {
  const formFields = {};
  form.find('input,textarea,select').each((i: number, el) => {
    if (el.name && el.tagName === 'select') {
      formFields[el.name] = $(el).find(':selected').val();
    } else if (el.name) {
      formFields[el.name] = el.value;
    }
  });
  return formFields;
}
